import { BrowserRouter } from 'react-router-dom';
import Modal from 'react-modal';

import AppProvider from './hooks';
import Routes from './routes';
import GlobalStyles from './styles/global';
import ScrollToTop from './hooks/scrollToTop';

// Accessibility reasons
Modal.setAppElement('#root');

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <GlobalStyles />
        <ScrollToTop />
        <Routes />
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
